// Contrat accord-cadre du titulaire engage sur un `lot_contrat` (pivot lot x contrat x rang).
//
// Vit dans la couche PARTAGEE, et non dans le service d'une page : les deux faces du bon de commande
// en ont besoin — l'acheteur (SuiviOperationBCV2, contrat du rang qu'il consulte) et le prestataire
// (SuiviDeCommandeBCV2, son propre contrat). Le dupliquer dans les deux services de page aurait fait
// deux verites a tenir synchrones pour un seul endpoint.
//
// Le PDF est renvoye en base64 : c'est la forme que `DocumentsList` consomme deja via son champ
// `binaire` (comme les `contrats_ac` du profil annuaire), donc aucun chemin de telechargement a cabler.

export interface ContratTitulaire {
  id: number;
  numero: string | null;
  /** Code du lot technique DU CONTRAT (et non de l'operation) : il nomme la piece. */
  lot_code: string | null;
  updated_at: string | null;
  /** PDF en base64. `null` quand le contrat n'en porte pas : l'appelant n'affiche alors pas de carte. */
  binaire: string | null;
}

/**
 * Titre de la piece contrat, IDENTIQUE a la gestion documentaire du profil
 * (`pages/Profil/tabs/TabDocuments.tsx`) : "CCAP + AE (lot XX) : contrat N°YY".
 * Defini ici pour que les deux vues du BC le partagent — trois formulations du meme document dans
 * l'app en feraient trois documents differents aux yeux de l'utilisateur.
 */
export const titreContratTitulaire = (contrat: ContratTitulaire): string =>
  `CCAP + AE (lot ${contrat.lot_code || ''}) : contrat N°${contrat.numero || contrat.id}`;

export const loadContratTitulaire = async (lotContratId: number): Promise<ContratTitulaire | null> => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error("Aucun token d'authentification trouvé");

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/bdc/lot-contrat/${lotContratId}/contrat`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    },
  );

  if (!response.ok) {
    const data = (await response.json().catch(() => ({}))) as { message?: string };
    throw new Error(data.message || `Erreur HTTP: ${response.status}`);
  }

  const body = (await response.json().catch(() => ({}))) as { data?: ContratTitulaire };
  return body.data ?? null;
};
